import {
  KinshipGroupType,
  KinshipType,
  SubscriptionDependentRuleType,
} from './rules.types';

export const subscriptionRuleForDependentWithoutExplicitRule =
  (): SubscriptionDependentRuleType => {
    return {
      id: -1,
      subscription_rule_id: null,
      absolute_price: 0,
      relative_price: 0,
      marital_status: null,
      is_additional_dependent: null,
      is_financial_dependent: null,
      kinship: null,
      min_age: null,
      max_age: null,
      created_at: null,
      updated_at: null,
    };
  };

export const KINSHIP_ADDITIONAL_DEPENDENT: KinshipType = {
  name: 'Dependente adicional',
  slug: 'additional_dependent',
  id: -1,
};

export const subscriptionRulesForAdditionalDependent = (
  subscriptionRules: SubscriptionDependentRuleType[],
  maxQuantityAdditional: number | null,
): KinshipGroupType => ({
  maxQuantityAdditional,
  kinship: KINSHIP_ADDITIONAL_DEPENDENT,
  groups: [
    {
      id: -1,
      kinship: KINSHIP_ADDITIONAL_DEPENDENT,
      marital_status: null,
      is_financial_dependent: null,
      min_age: null,
      max_age: null,
      maxQuantity: null,
      siblingGroup: [
        {
          id: -1,
          marital_status: null,
          min_age: null,
          max_age: null,
          is_financial_dependent: null,
          maxQuantity: null,
          kinship: {
            ...KINSHIP_ADDITIONAL_DEPENDENT,
            name: 'Dependentes adicionais',
          },
        },
      ],
      subscriptionRules,
    },
  ],
});

export const INFO_BANNER_MESSAGES = {
  additional:
    'Dependentes adicionais são os que não se encaixam nas outras regras (considerando grau de parentesco, idade, estado civil, dependência financeira e quantidade).',
  default: 'Para outros casos, será considerado como dependente adicional.',
};
